
<template>
  <div id="app" style="pageStyle">

    <router-view />
  </div>
  
</template>

<script>

export default {

  name: 'CustomerAppVue',

  components: {},

  props: {
    app: String,
  },


  data() {
    return {
    }
  },

  created() {
    if (process.env.NODE_ENV !== 'production') console.log("INIT %c CustomerAppVue", "color: black; background-color: Coral;padding: 2px");

    // set store items 
    if (process.env.NODE_ENV !== 'production') console.log("CUSTOMER STORE", this.$store.state.customer);


  },

  computed: {
    pageStyle() {
      return {
        background: "#1b1e21"
      }
    }
  },

  methods: {},

}
</script>

<style>
/* .q-notification .q-notification__wrapper {
  max-width: 375px;
} */

.q-notification {
  min-width: 300px;
  max-width: 500px;
}


/* #app {
  background-color: var(--bkg); */

/* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
/* } */
</style>

<style lang="sass">
.t-style
  .q-table__top,
  .q-table__bottom
    padding: 0px

  thead tr th
    position: sticky
    z-index: 1
</style>